import {generate} from 'helpers';
import {Entity, Note} from 'types';
import {select} from 'store/helpers';
import {findCategory} from '../selectors/categories';

export const update = (note: Note) => ({
  type: 'NOTES_UPDATE' as const,
  note: {
    ...note,
    id: note.id ?? generate()
  },
  category: select(findCategory)(note.category || 'Notes') ?? {
    id: generate(),
    name: note.category
  }
});

export const updateText = (id: string, text: string) => ({
  type: 'NOTES_TEXT_UPDATE' as const,
  id,
  text
});

export const updateCategory = (category: {id?: string, name: string}) => ({
  type: 'NOTES_CATEGORY_UPDATE' as const,
  id: category.id ?? generate(),
  name: category.name
});

export const remove = (note: Note) => ({
  type: 'NOTES_DELETE' as const,
  id: note.id
});

export const removeCategory = (category: Entity) => ({
  type: 'NOTES_CATEGORY_DELETE' as const,
  id: category.id
});
